import React from 'react';
import {ContentContainer} from './styled';
import {ReceiptTable} from './components/ReceiptTable';
// import {fetchLastReceiptFx} from '../../../models/header';

export function Receipt() {
  // fetchLastReceiptFx handler is commented out in models/header/init.ts,
  // so the corresponding code is commented out here as well.
  // also setInterval is used, but the cleanup uses clearTimeout

  // useEffect(() => {
  //   const timer = setInterval(fetchLastReceiptFx, 30000);
  //   return () => clearTimeout(timer);
  // }, []);
  return (
    <ContentContainer>
      <ReceiptTable />
    </ContentContainer>
  );
}
